import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { SelectionStateService } from './selection-state.service';
import { USER_ROLE } from '../types/user-role.types';

/** Raíz: RedirectingComponent resuelve el destino según rol y sesión. */
const ROOT_ROUTE = '/';

/**
 * Retiene la activación de las pantallas cuyo scope depende del rol (reportes
 * de jefe de ventas / administrador) hasta que el rol persistido está leído.
 *
 * Los reportes mandan `role` a `/sales-manager/*` para que el back acote el
 * scope. Cuando el param no viaja, el back mantiene a propósito el
 * comportamiento viejo — toda la productora — y NO falla, así que un `ngOnInit`
 * que gana la carrera contra la inicialización muestra datos de más sin ningún
 * error visible. El guard cierra esa ventana.
 *
 * `whenRoleRestored()` resuelve tanto si la inicialización termina bien como si
 * falla, así que un `/me` caído no deja la navegación colgada.
 */
@Injectable({ providedIn: 'root' })
export class RoleReadyGuard implements CanActivate {

  constructor(
    private readonly _selectionState: SelectionStateService,
    private readonly _router: Router,
  ) { }

  async canActivate(): Promise<boolean | UrlTree> {
    await this._selectionState.whenRoleRestored();

    const role = this._selectionState.getSelectedRoleValue();

    if (!role || role === USER_ROLE.UNKNOWN) {
      // Sin rol no hay scope posible: antes de dejar que la pantalla dispare
      // requests indeterminados, que la raíz decida a dónde va (los `sellers` ya no eligen rol).
      return this._router.createUrlTree([ROOT_ROUTE]);
    }

    return true;
  }

}
